import { useMutation, useQuery, useQueryClient } from "react-query";
import { fetchCustomer, fetchCustomers, postCustomer } from "../api/CustomerApi";

//////////////////////////////////////////////////////
//-------------------- CUSTOMER --------------------//
//////////////////////////////////////////////////////

//--- get customers ---//
export const GetCustomers = () => {
  return useQuery(["customers"], fetchCustomers);
};

//--- get single customer ---//
export const GetCustomer = (customerId) => {
  return useQuery(["customer", customerId], fetchCustomer, {
    enabled: !!customerId,
  });
};

//--- Create Customer  ---//
export const CreateCustomer = (options) => {
  const queryClient = useQueryClient();

  return useMutation((newCustomer) => postCustomer(newCustomer), {
    onSuccess: (newCustomer) => {
      console.log("Invalidating facilities query...");
      queryClient.invalidateQueries(["customers"]);

      if (options?.onSuccess) options.onSuccess(newCustomer);
    },
    onError: options?.onError,
  });
};

//--- get customer ---//
// export const GetCustomer = (customerId) => {
//   const queryClient = useQueryClient();
//   return useQuery(["customer", customerId], api.fetchCustomer, {
//     initialData: () => {
//       const customer = queryClient
//         .getQueryData("customer")
//         ?.data.find((customer) => customer.id === parseInt(customerId));
//       if (customer) {
//         return {
//           data: customer,
//         };
//       } else {
//         return undefined;
//       }
//     },
//   });
// };

// //--- create customer ---//
// export const CreateCustomer = () => {
//   return useMutation(api.postCustomer);
// };

// //--- update customer ---//
// export const UpdateCustomer = () => {
//   const queryClient = useQueryClient();
//   return useMutation(api.putCustomer, {
//     onSettled: () => queryClient.invalidateQueries(["customers"]),
//   });
// };

//--- delete customer ---//

///////////////////////////////////////////////////////
//-------------------- COSTPLACE --------------------//
///////////////////////////////////////////////////////
